import { LucideSendHorizontal } from "lucide-react";
import React from "react";
import { ChatInputProps } from "../Types/Types";

export const ChatInput: React.FC<ChatInputProps> = ({ onSend }) => {
  const [message, setMessage] = React.useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (message.trim()) {
      onSend(message);
      setMessage("");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="border-t border-[#e1e1e1]">
      <div className="flex items-center gap-2 rounded-lg bg-[#f5f5f5] p-2">
        <textarea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Ask me something or type / for questions.."
          className="h-[32px] w-full resize-none rounded-lg border border-[#e1e1e1] bg-transparent p-1 text-sm text-[#202020] focus:outline-none"
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              handleSubmit(e);
            }
          }}
        />
        <div className="flex items-center justify-end gap-2">
          <button
            type="submit"
            className="rounded-lg border border-[#e1e1e1] p-1.5 text-gray-500 transition-colors hover:text-[#202020]"
          >
            <LucideSendHorizontal className="h-4 w-4" />
          </button>
        </div>
      </div>
    </form>
  );
};
